<script>
import { mapGetters } from 'vuex'
import GeneralTags from '@/components/organism/restaurants/GeneralTags.vue'
export default {
    name: 'TagsSelect',
    components: {
        GeneralTags,
        TagsWrapper: () => import('@/components/organism/restaurants/TagsWrapper'),
    },
    computed: {
        ...mapGetters({
            groups: 'tags/groups',
            loaded: 'tags/loaded',
        }),

        filteredGroups() {
            const filteredGroups = []
            for (let group of this.groups) {
                const filteredGroup = {
                    ...group,
                    items: [],
                }
                for (let tag of group.items) {
                    let hasInResult = this.$restaurants.tagCounts[tag.slug]
                    if (!hasInResult) {
                        hasInResult = 0
                    }

                    filteredGroup.items.push({
                        ...tag.model,
                        restaurant_count: hasInResult,
                    })
                }

                filteredGroups.push(filteredGroup)
            }

            return filteredGroups
        },
    },
}
</script>

<template lang="pug">
.filters.pb-6
    general-tags
    tags-wrapper(
        v-for="(group, index) in filteredGroups"
        :key="`filterGroup-${group.tag_group.id}`"
        :group="group")
</template>
